var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGlass = function SvgGlass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.792,
    height: 16.156,
    viewBox: "0 0 18.792 16.156",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15112",
    "data-name": "Group 15112",
    transform: "translate(-198.238 -267.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M18.792,14.752,14.584,11.1A6.247,6.247,0,0,0,16.2,7.023C16.2,3.231,12.639,0,8.1,0S0,3.09,0,7.023c0,3.792,3.565,7.023,8.1,7.023a8.638,8.638,0,0,0,4.7-1.4l4.208,3.515ZM1.62,7.023C1.62,3.933,4.537,1.4,8.1,1.4s6.482,2.528,6.482,5.618S11.667,12.641,8.1,12.641,1.62,10.113,1.62,7.023Z",
    transform: "translate(198.238 267.819)",
    fill: "#939393"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glass.b688d16f.svg";
export { ForwardRef as ReactComponent };